var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 4.82153,
    width: 31.5,
    height: 22.3571,
    rx: 1.46429,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8027_4168",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 32,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 4.82153,
    width: 31.5,
    height: 22.3571,
    rx: 1.46429,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8027_4168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.1906H32V4.57153H0V12.1906Z",
    fill: "#FFA44A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 27.4286H32V19.8096H0V27.4286Z",
    fill: "#1A9F0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.0001,
    cy: 16.0001,
    r: 2.57143,
    fill: "#181A93",
    fillOpacity: 0.15,
    stroke: "#181A93",
    strokeWidth: 0.571429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.0001,
    cy: 16.0002,
    r: 0.761905,
    fill: "#181A93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.1e02dc503420365b9794eecb4d648485.svg";
export { ForwardRef as ReactComponent };